import React, { FC } from 'react';
import ProfileConditionsVO, { JobGroupVO } from '@domain/vo/profile/ProfileConditionsVO';
import { WelfareDto } from '@domain/rs/profile/ProfileConditionsRs';

import classnames from 'classnames/bind';
import styles from './prefer.module.scss';
const cx = classnames.bind(styles);

interface IJobGroupContentsProps {
  jobGroups: JobGroupVO[];
}

const JobGroupContents: FC<IJobGroupContentsProps> = ({ jobGroups }) => {
  if (!jobGroups.length) return null;

  const jobGroupsEl = jobGroups.map((item) => {
    const { jobGroupCode, jobGroupName, jobTitles } = item;

    const jobTitlesEl = jobTitles.map((jobTitle) => {
      return (
        <li key={jobTitle.jobTitleCodes} className={cx('listItem')}>
          {jobTitle.jobTitleNames}
        </li>
      );
    });

    return (
      <div key={jobGroupCode} className={cx('detailInfoInner')}>
        <span className={cx('detailInfoTitle')}>{jobGroupName}</span>
        <div className={cx('detailInfoWrap')}>
          <ul className={cx('detailInfoList')}>{jobTitlesEl}</ul>
        </div>
      </div>
    );
  });

  return (
    <div className={cx('infoWrap')}>
      <em className={cx('infoTitle')}>희망 직군 · 직무</em>
      <div className={cx('detailInfoArea')}>{jobGroupsEl}</div>
    </div>
  );
};

interface ILocationContentsProps {
  locationTextList: string[];
}

const LocationContents: FC<ILocationContentsProps> = ({ locationTextList }) => {
  if (!locationTextList.length) return null;

  const isSelectedAllLocation = locationTextList.length >= 17; //전체 지역 선택 여부
  const allLocationEl = <li className={cx('listItem')}>{'전체 지역'}</li>;

  const locationsEl = isSelectedAllLocation
    ? allLocationEl
    : locationTextList.map((name, idx) => {
        return (
          <li key={idx} className={cx('listItem')}>
            {name}
          </li>
        );
      });

  return (
    <div className={cx('infoWrap')}>
      <em className={cx('infoTitle')}>희망 근무지역</em>
      <div className={cx('detailInfoArea')}>
        <div className={cx('detailInfoWrap')}>
          <ul className={cx('detailInfoList')}>{locationsEl}</ul>
        </div>
      </div>
    </div>
  );
};

interface ISalaryContentsProps {
  salary: number | null;
}

const SalaryContents: FC<ISalaryContentsProps> = ({ salary }) => {
  if (!salary) return null;

  return (
    <div className={cx('infoWrap')}>
      <em className={cx('infoTitle')}>희망 연봉수준</em>

      <div className={cx('detailInfoArea')}>
        <div className={cx('salaryArea')}>
          <span className={cx('salaryBox')}>{salary.toLocaleString()}</span>만원 이상
        </div>
      </div>
    </div>
  );
};

interface IWelfareContentsProps {
  welfareList: WelfareDto[];
}

const WelfareContents: FC<IWelfareContentsProps> = ({ welfareList }) => {
  if (!welfareList.length) return null;

  const welfareEl = welfareList.map((item) => {
    return (
      <li key={item.code} className={cx('listItem')}>
        {item.name}
      </li>
    );
  });

  return (
    <div className={cx('infoWrap')}>
      <em className={cx('infoTitle')}>희망 복지혜택</em>

      <div className={cx('detailInfoArea')}>
        <div className={cx('detailInfoWrap')}>
          <ul className={cx('detailInfoList')}>{welfareEl}</ul>
        </div>
      </div>
    </div>
  );
};

interface IPreferContentsProps {
  profileCondition: ProfileConditionsVO;
}

const PreferContents: FC<IPreferContentsProps> = ({ profileCondition }) => {
  const { jobGroups, locationTexts, salary, welfare } = profileCondition;

  return (
    <div className={cx('infoInner')}>
      <JobGroupContents jobGroups={jobGroups} />
      <LocationContents locationTextList={locationTexts} />
      <SalaryContents salary={salary} />
      <WelfareContents welfareList={welfare} />
    </div>
  );
};

export default PreferContents;
